<template>
  <FaIcon :icon="['fas', ICON.WIFI]" />
</template>

<script setup lang="ts">
import { ICON } from '@/constants/icons';
</script>
